import { render, staticRenderFns } from "./BadConscienceDialog.vue?vue&type=template&id=f6a5a19a"
import script from "./BadConscienceDialog.vue?vue&type=script&lang=ts"
export * from "./BadConscienceDialog.vue?vue&type=script&lang=ts"
import style0 from "./BadConscienceDialog.vue?vue&type=style&index=0&id=f6a5a19a&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports